<template>
	<div class="animated fadeIn">
		<h1 class="text-light">{{$t('user_history.title')}}</h1>

		<b-row>

			<b-col xl="12" lg="12" md="12">
		        <b-card v-if="show_usage_line_chart" no-body>
		          <div slot="header">
		            <i class="fa fa-area-chart"></i> {{$t('user_history.history_request')}}
		          </div>
		          
		          <b-card-body class="p-4">
		          	<b-form inline>
		          		<b-input-group class="mb-1">
		          			<b-input-group-prepend>
		          				<b-input-group-text>{{$t('user_history.common_era')}}</b-input-group-text>
		          			</b-input-group-prepend>
		            		<v-select v-model="selected_year" :options="year_options"></v-select>
		            	</b-input-group> &nbsp;&nbsp;&nbsp;
		            	<b-input-group class="mb-1">
		          			<b-input-group-prepend>
		          				<b-input-group-text>{{$t('user_history.month')}}</b-input-group-text>
		          			</b-input-group-prepend>
		            		<v-select v-model="selected_month" :options="month_options"></v-select>
		            	</b-input-group> &nbsp;&nbsp;&nbsp;
		            	<b-input-group class="mb-1">
		            		<b-button variant="info" class="text-white" @click="generateReports()"><b><i class="fa fa-file-excel-o"></i> {{$t('user_history.report_generation')}}</b></b-button>
		            	</b-input-group>
		        	</b-form>
		          </b-card-body>
		        </b-card >

		        <b-card :header="$t('line_graph')" v-if="show_usage_line_chart">
        			<div class="chart-wrapper">
		        		<history-line-chart :data="usage_line_chart_data"/>
		        	</div>
		        </b-card>

		        <b-card v-if="show_usage_list">
		        	<v-server-table
                class="d-none d-md-block d-lg-block d-xl-block"
                :columns="logcolumns"
                :data="logdata"
                :options="logoptions"
                :theme="theme"
                ref="logDataTable"
                id="logDataTable">
						    <a slot="location" slot-scope="props">{{props.row.Device && props.row.Device.name ? props.row.Device.name : $t('unknow')}}</a>
    						<a slot="status" slot-scope="props">
    							<span class="text-primary" v-if="props.row.status==='start'">{{$t('charging')}}</span>
								<span class="text-primary" v-if="props.row.status==='stop'">{{$t('idling')}}</span>
    							<span class="text-warning" v-if="props.row.status==='end'">{{$t('charging_done')}}</span>
    						</a>
    						<a slot="start_time" slot-scope="props">{{props.row.start_time|htime}}</a>
							<a slot="stop_time" slot-scope="props">{{props.row.stop_time|htime}}</a>
    						<a slot="end_time" slot-scope="props">{{props.row.end_time|htime}}</a>
							<a slot="billing_method" slot-scope="props">{{props.row.billing_method === 'TIME' ? $t('time') : $t('kwh')}}</a>
    						<a slot="interval" slot-scope="props">{{props.row.billing_method === 'TIME' ? (Math.ceil(props.row.used_time/60) + Math.ceil(props.row.used_time_peak/60)) + $t('minute') : (props.row.interval|interval) + $t('second')}}</a>
    						<a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>
							<a slot="used_value" slot-scope="props">{{get_used_value(props.row)}}</a>
							<a slot="price" slot-scope="props">{{props.row.price}}/{{props.row.price_peak}}{{props.row.billing_method ==='TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}</a>
							<a slot="used_time_idle" slot-scope="props">{{props.row.stop_time > 0 ? $math.floor(props.row.used_time_idle / 60 ) + '分鐘' : 'N/A'}}</a>
							<a slot="price_idle" slot-scope="props">{{props.row.stop_time > 0 ? $math.round(props.row.price_idle, 2) + '點(' + props.row.idle_info + ')': 'N/A'}}</a>
							<!-- <a slot="sub_total" slot-scope="props">{{props.row.Device.charge_first ? (props.row.Transaction && props.row.Transaction.valid ? $math.round(props.row.Device.charge_value/1.15, 2) : 0) : props.row.used_watts < 1 ? 0 : props.row.sub_total}}</a>-->
							<a slot="sub_total" slot-scope="props">{{props.row.sub_total}}</a>
					    </v-server-table>

              <b-card
                v-if="card_records.length"
                v-for="(entry, idx) in card_records"
                :v-key="`history-entry-{idx}`"
                :header="`${entry.Device.name} @ ${entry.Device.geo_location}`"
                class="d-none d-block d-sm-block d-md-none d-lg-none d-xl-none">
                <div class="col-12">
                  <label class="">{{$t('status')}}：</label>
				  <span v-if="entry.status==='start'">{{$t('charging')}}</span>
				  <span v-if="entry.status==='stop'">{{$t('idling')}}</span>
				  <span v-if="entry.status==='end'">{{$t('charging_done')}}</span>
                </div>
                <div class="col-12">
                  <label class="">{{$t('start_time')}}：</label>
                  <span>{{entry.start_time|htime}}</span>
                </div>
                <div v-if="entry.stop_time" class="col-12">
                  <label class="">{{$t('stop_time')}}：</label>
                  <span>{{entry.stop_time|htime}}</span>
                </div>
                <div class="col-12">
                  <label class="">{{$t('end_time')}}：</label>
                  <span>{{entry.end_time|htime}}</span>
                </div>
                
				<div class="col-12">
					<label class="">{{$t('billing_method')}}：</label>
					<span>{{entry.billing_method ==='TIME'?$t('time'):$t('kwh')}}</span>
				</div>
				<div class="col-12">
                  <label class="">{{entry.billing_method ==='TIME' ? $t('total_used_time') : $t('used_time')}}：</label>
                  <span v-if="entry.billing_method ==='TIME'">{{(Math.ceil(entry.used_time/60) + Math.ceil(entry.used_time_peak/60))}}{{$t('minute')}}</span>
				  <span v-else>{{entry.interval|interval}}</span>
                </div>
                <div class="col-12" v-if="(entry.billing_method ==='TIME') && !entry.Device.charge_first">
                  <div class="">{{$t('user_history.used_time_field')}}：</div>
				  <label v-if="entry.sub_total == 0 && entry.price != 0">0/0 {{$t('minute')}}</label>
				  <label v-if="entry.sub_total > 0 || entry.price == 0">{{Math.ceil(entry.used_time/60)}}/{{Math.ceil(entry.used_time_peak/60)}} {{$t('minute')}}</label>
                </div>
				<div class="col-12" v-if="!(entry.billing_method ==='TIME') && !entry.Device.charge_first">
					<div class="">{{$t('user_history.used_kwh_field')}}：</div>
					<label v-if="entry.sub_total == 0 && entry.price != 0">0.000/0.000 {{$t('kwh')}}</label>
					<label v-if="entry.sub_total > 0 || entry.price == 0">{{entry.used_watts}}/{{entry.used_watts_peak}} {{$t('kwh')}}</label>
				</div>
                <div class="col-12" v-if="!entry.Device.charge_first">
                  <div class="">{{$t('user_history.price_field')}}：</div>
				  <label>{{entry.price}}/{{entry.price_peak}} {{entry.billing_method ==='TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}</label>
                </div>

				<div class="col-12" v-if="!entry.Device.charge_first && entry.stop_time">
				  <div class="">{{$t('user_history.idle_used_time')}}：</div>
				  <label>{{$math.floor(entry.used_time_idle/60)}}{{$t('minute')}}</label>
				</div>

				<div class="col-12" v-if="!entry.Device.charge_first && entry.stop_time">
				  <div class="">{{$t('user_history.idle_charge')}}：</div>
				  <label>{{Number($math.round(entry.price_idle, 2))}}{{$t('points')}}/{{get_idle_interval_rate(entry.idle_info)}}{{$t('minute')}}</label>
				  <label>({{$t('user_history.idle_free_info', { idle_free_period : get_idle_free_period(entry.idle_info) })}})</label>
				  <label v-if="get_idle_max_price(entry.idle_info) > 0">({{$t('user_history.idle_max_price', { idle_max_price : get_idle_max_price(entry.idle_info) })}})</label>
				</div>

				<div class="col-12" v-if="!entry.Device.charge_first">
				  <label class="">{{$t('user_history.consume_points')}}：</label>
				  <span>{{entry.sub_total}} {{$t('s_points')}} ({{$math.round(entry.sub_total * 115) / 100}} {{$t('price_unit')}})</span>
				</div>
                <div class="col-12" v-if="entry.Device.charge_first && entry.used_watts > 1">
                  <label class="">{{$t('user_history.one_time_charge')}}：</label>
                  <span>{{entry.Device.charge_value}}{{$t('s_points')}}</span>
                </div>
              </b-card>

              <div class="d-none d-inline-block d-sm-inline-block d-md-none d-lg-none d-xl-none col-12 overflow-auto">
                <b-pagination
                  align="center"
                  v-if="card_records.length"
                  v-model="card_current_page"
                  :total-rows="card_record_count"
                  :per-page="card_limit"
                  @input="gotoPage">
                </b-pagination>
              </div>
		    	</b-card>
		    </b-col>
	        
		</b-row>

    <b-modal :title="$t('qrcode_scanning')" v-model="showCameraModal" :ok-title="$t('ok')" :ok-only="true" :hide-footer="true" @hidden="hideScanner()">
      <b-alert :show="showCameraModal" variant="success"><i class="fa fa-exclamation-triangle"></i> {{$t('please_qrcode_scanning')}}</b-alert>
      <!-- <canvas id="qrcode-window" v-if="show_qrcode_canvas"></canvas> -->
      <!-- <video id="qrcode-video" playsinline muted></video> -->
      <video
        v-show="showCameraModal"
        id="qrvideo"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        style="border: 1px solid gray; width: 100%; height: 100%"></video>
      <p class="text-primary">{{qrcode_string}}</p>
    </b-modal>

		<b-modal :title="$t('error_message')" v-model="showErrorModal" :ok-title="$t('ok')" :ok-only="true">
	    	<b-alert :show="showErrorModal" variant="danger"><i class="fa fa-exclamation-triangle"></i> {{errorMsg}}</b-alert>
		</b-modal>
	</div>
</template>
<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import { hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import {ServerTable, Event} from 'vue-tables-2'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import io from 'socket.io-client'
import moment from 'moment-timezone'

import HistoryLineChart from '@/views/HistoryLineChart'

import { BrowserQRCodeReader } from '@zxing/library';

const codeReader = new BrowserQRCodeReader();

let eventbus = config.eventbus;
let scanner  = null;

Vue.use(ServerTable)

let getUrlParameter = function getUrlParameter(url) {
  let sPageURL = url.substring(url.indexOf('?')+1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i,
      rlt={};

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      rlt[sParameterName[0]] = sParameterName[1];
  }

  return rlt;
};//eo getUrlParameter

export default {
	name: 'UserHistory',
	components: {
		vSelect,
		HistoryLineChart,
		ServerTable,
		Event,
	},
	notifications,
	data(){

		let $tz = moment().tz(config.timezone);
    	let root = this;

		let selected_year = $tz.format('YYYY');
		let year_options  = [
			selected_year,
			$tz.subtract(1, 'year').format('YYYY')
		];

		$tz = moment().tz(config.timezone);

		let selected_month = $tz.format('MM');
		let month_options  = [];

		// console.info('selected_month:', selected_month);

		for(let i = 1 ; i <= 12 ; i++){
			month_options.push( i <= 9 ? '0' + i : '' + i );			
		}

		return {
			selected_year,
			year_options,
			selected_month,
			month_options,
			theme: '',
			usage_line_chart_data: [],
			logdata: [],
			card_records: [],
			card_record_count: 0,
			card_record_total_page: 1,
			card_current_page: 1,
			card_limit: 25,
			show_usage_line_chart: false,
			show_usage_list: true,
			start_time:'',
			end_time:'',
			showErrorModal: false,
			showCameraModal: false,
			qrcode_string: '',
			errorMsg:'',
			logcolumns: ['location', 'start_time', 'stop_time', 'end_time', 'status', 'billing_method', 'interval', 'used_value', 'price', 'used_time_idle', 'price_idle', 'sub_total'],
			logoptions: {
				headings: {
					// company_id: '公司',
					location: this.$t('user_history.logoptions.location'),
					start_time: this.$t('user_history.logoptions.start_time'),
					stop_time: this.$t('user_history.logoptions.stop_time'),
					end_time: this.$t('user_history.logoptions.end_time'),
					status: this.$t('user_history.logoptions.status'),
					billing_method: this.$t('user_history.logoptions.billing_method'),
					interval: this.$t('user_history.logoptions.interval'),
					used_value: this.$t('user_history.logoptions.used_value'),
					price: this.$t('user_history.logoptions.price'),
					used_time_idle: this.$t('user_history.logoptions.used_time_idle'),
					price_idle: this.$t('user_history.logoptions.price_idle'),
					sub_total: this.$t('user_history.logoptions.sub_total'),
					// created: '紀錄'
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: ['location', 'start_time', 'end_time', 'status', 'interval', 'sub_total', 'created'],
				filterable: ['location', 'start_time', 'end_time', 'status', 'interval', 'sub_total', 'created'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					let app = this;
					let action = `${config.mqtt_root}/get_charging_records`;
					let params = {
						// token: app.$state.$get('adminuser').token,
						user_id: encodeURIComponent(this.$state.$get('user').uuid),
						keyset: 'mqtt',
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.$state.$get('user').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						root.card_records = result.data || [];
						root.card_record_count = result.count || 0;
						root.card_current_page = params.page;
						root.card_limit = params.limit;
						if (root.card_record_count) {
							root.card_record_total_page = Math.ceil(root.card_record_count / params.limit);
						}
						// console.info('app.card_records: ', root.card_records);
						return {
							data: result.data || [],
							count: result.count || 0
						};
					}).catch(error => {
						return {
							data: [],
							count: 0
						};
					});
				}//eo requestFunction
			},
      		cameraDevices: [],
		}
	},//eo data
  	created() {
		let app = this;

		app.$on('qrcodeDetected', function(result){
			// console.info('qr result:', result);

			app.$emit('reveived-qrcode', result);
			app.show_qrcode_canvas = false; 
			app.showCameraModal    = false;

			let params = getUrlParameter(result);

			if(params && params.uuid){
				app.uuid = decodeURIComponent(params.uuid);
				app.$state.$set('uuid', app.uuid);

				//Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
				let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
				uuid: app.uuid
				});

				// console.info('href:', href);

				window.location = href;

				location.reload();
			}
		});
  	},
	mounted() {
		let app   = this;
		let user  = this.$state.$get('user');
		let token = user ? this.$state.$get('user').token : null;

    	// console.info(token);

		if(!token){
			this.$state.$set('error', config.error.INVALID_USER);
	    this.$router.push('/');
	    return;
		}

    	eventbus.$on('start-qrcode-scanning', this.openQrCodeScanner);

		jQuery('.VueTables__search-field input').attr('placeholder', this.$t('search'));
		
	},//eo mounted

	watch: {
		'$i18n.locale'() {
			//console.info('watch $i18n.locale');
			this.$nextTick(() => {
				this.updateTableOptions();
			});
		},
	},

	methods: {
		openQrCodeScanner() {
		let app = this;

		app.showCameraModal       = true
		app.show_scan_qrcode_msg = true;
		app.show_qrcode_canvas   = true;

		// let _ccc = setTimeout(() => {
		//  clearTimeout(_ccc);
		//  init_qrcode_reader(app);
		// }, 1000);

		codeReader
		.listVideoInputDevices()
		.then((videoInputDevices) => {
			let targetCamera;
			videoInputDevices.forEach((device) => {
			this.cameraDevices.push(`${device.label}, ${device.deviceId}`);
			if (this.camera === 'front' && device.label.toLowerCase().indexOf('front') !== -1) {
				targetCamera = device.deviceId;
				return false;
			}
			return true;
			});
			codeReader
			.decodeFromInputVideoDevice(undefined, 'qrvideo')
			.then(result => this.onDecode(result.text))
			.catch(err => {
			// this.showError({message:this.$t('qr_code_detect_error')});
			console.error(err)
			});
		})
		.catch(err => { 
			this.showError({message:this.$t('qr_code_detect_error')});
			console.error(err)
		});

		},//eo openQrCodeScanner
		onDecode(data) {
		this.$emit('qrcodeDetected', data);
		this.showSuccess({message:this.$t('qr_code_detected')});
		},
		hideScanner(){
		// let app = this;
		// app.getVideo().stop();
		if(scanner !== null && scanner.destroy){
			scanner.destroy();
			scanner = null;
		}
		},//eo hideScanner
		gotoPage(page) {
		// console.info('new page: ', page);
		this.$refs.logDataTable.setPage(page);
		},
		get_used_value(row) {
			let used_value = '0.000/0.000' + this.$t('unit_kwh');
			if(row) {
				if(row.billing_method == 'TIME') {
					if(row.sub_total == 0 && row.price != 0){
						used_value = '0/0' + this.$t('minute');
					} else {
						used_value = Math.ceil(row.used_time/60) + '/' + Math.ceil(row.used_time_peak/60) + this.$t('minute');
					}	
				} else {
					if(row.sub_total == 0 && row.price != 0) {
						used_value = '0.000/0.000' + this.$t('unit_kwh');
					} else {
						used_value = row.used_watts + '/' + row.used_watts_peak + this.$t('unit_kwh');
					}
				}
			}
			return used_value;
		},//eo get_used_value
		generateReports() {
			let app            = this;
			let selected_year  = app.selected_year;
			let selected_month = app.selected_month;

			if(!selected_year || !selected_month){
				app.showError({
					message: app.$t('select_year_month')
				});
				return;
			}

			// console.info(`selected year: ${app.selected_year}, selected_month:${app.selected_month}`);
			let action = `${config.mqtt_root}/get_charging_records`;
			fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + this.$state.$get('user').token
				},
				body: JSON.stringify({
					user_id: encodeURIComponent(this.$state.$get('user').uuid),
					keyset: 'mqtt',
					selected_month,
					selected_year
				})
			}).then(res => res.json()).then(charging_records => {
				if(charging_records.success && charging_records.records.length){

					let formatted = {};
					let labels    = [];
					let datasets  = [];
					let preset    = {};
					let endday_of_month = moment(`${selected_year}${selected_month}`, "YYYYMM").tz(config.timezone).daysInMonth();

					for(let i = 1; i <= parseInt(endday_of_month) ; i++){
						labels.push(i <= 9 ? `0${i}` : `${i}`);
					}

					charging_records.records.forEach((record) => {
						let key = record.Device.geo_location;

						if(preset[key] === undefined){
							preset[key] = {
								label: key,
								data: []
							}

							labels.forEach((date) => {
								preset[key]['data'][(parseInt(date)-1)] = 0;
							});
						}

						let date_key = parseInt(moment(record.start_time*1000).tz(config.timezone).format('DD')) - 1;

						// console.info('_dd:', moment(record.start_time*1000).tz(config.timezone).format('YYYYMMDD'));

						preset[key]['data'][date_key] += (record.used_watts/1000);
					});

					// console.info('preset:', preset);

					let idx = 1;
					let jdx = 1;
					for(let location in preset){
						console.info('RGB: ', '#' + (15000 + idx * 128).toString(16));
						datasets.push({
							label: preset[location].label,
							data: preset[location].data,
							backgroundColor: hexToRgba('#' + (15000 + idx * 128).toString(16) + `F${jdx}`, 90)
						});
						idx += 128;
						jdx++;
					}

					formatted = {
						labels,
						datasets
					};

					app.usage_line_chart_data = formatted;

					console.info('formatted:', formatted);

					if(datasets.length){
						app.show_usage_line_chart = true;
					}

				} else {
					app.showWarn({
						message: app.$t('no_charging_record')
					});
					app.usage_line_chart_data = [];
					app.show_usage_line_chart = false;
				}
			}).catch(error => {
				app.showWarn({
					message: app.$t('no_charging_record')
				});
				app.usage_line_chart_data = [];
				app.show_usage_line_chart = false;
			});
		},
		updateTableOptions() {
			this.logoptions.headings.location = this.$t('user_history.logoptions.location');
			this.logoptions.headings.start_time = this.$t('user_history.logoptions.start_time');
			this.logoptions.headings.end_time = this.$t('user_history.logoptions.end_time');
			this.logoptions.headings.status = this.$t('user_history.logoptions.status');
			this.logoptions.headings.billing_method = this.$t('user_history.logoptions.billing_method');
			this.logoptions.headings.interval = this.$t('user_history.logoptions.interval');
			this.logoptions.headings.used_value = this.$t('user_history.logoptions.used_value');
			this.logoptions.headings.price = this.$t('user_history.logoptions.price');
			this.logoptions.headings.sub_total = this.$t('user_history.logoptions.sub_total');
			this.$forceUpdate();
		},
		get_idle_interval_rate(idle_info) {
			let [idle_free_period, idle_interval_rate, idle_max_price] = idle_info.split('/');
			return idle_interval_rate;
		},
		get_idle_free_period(idle_info) {
			let [idle_free_period, idle_interval_rate, idle_max_price] = idle_info.split('/');
			return idle_free_period;
		},
		get_idle_max_price(idle_info) {
			let [idle_free_period, idle_interval_rate, idle_max_price] = idle_info.split('/');
			return idle_max_price;
		}
	},//eo methods
}
</script>

<style>
.breadcrumb{display: none;}
.pt-3, .py-3 { padding-top: 0.35rem !important; }
.VueTables__search-field label, .VueTables__limit-field label{
	display: none;
	width: 0px;
}
</style>

<style src="spinkit/scss/spinkit.scss" lang="scss" />